<table class="myDpCalTable" [ngClass]="{'ng-myrtl': opts.rtl, 'myDpFooter': opts.showFooterToday, 'myDpNoFooter': !opts.showFooterToday, 'myDpViewChangeAnimation': opts.viewChangeAnimation && viewChanged}">
  <thead>
    <tr>
      @if (opts.showWeekNumbers && opts.firstDayOfWeek==='mo') {
        <th class="myDpWeekDayTitle myDpWeekDayTitleWeekNbr">#</th>
      }
      @for (d of weekDays; track $index) {
        <th class="myDpWeekDayTitle" scope="col">{{d}}</th>
      }
    </tr>
  </thead>
  <tbody>
    @for (w of dates; track $index) {
      <tr>
        @if (opts.showWeekNumbers && opts.firstDayOfWeek==='mo') {
          <td class="myDpDaycellWeekNbr">{{w.weekNbr}}</td>
        }
        @for (d of w.week; track $index) {
          <td
            id="d_{{d.row}}_{{d.col}}"
            class="d_{{d.row}}_{{d.col}} myDpDaycell {{d.markedDate.styleClass}} {{d.disabledDate.styleClass}}"
          [ngClass]="{'myDpRangeColor': isDateInRange(d.dateObj) || d.range,
                'myDpPrevMonth': d.cmo === prevMonthId,
                'myDpCurrMonth':d.cmo === currMonthId && !d.disabledDate.disabled,
                'myDpNextMonth': d.cmo === nextMonthId,
                'myDpSelectedDay':isDaySelected(d),
                'myDpRangeBegin':this.opts.dateRange && isDateRangeBegin(d.dateObj),
                'myDpRangeEnd':this.opts.dateRange && isDateRangeEnd(d.dateObj),
                'myDpDisabled': d.disabledDate.disabled && !d.disabledDate.styleClass.length,
                'myDpTableSingleDay': !d.disabledDate.disabled}"
            [attr.aria-current]="d.currDay ? 'date' : null"
            [attr.aria-disabled]="d.disabledDate.disabled || null"
            [attr.aria-selected]="isDaySelected(d) || null"
            [attr.tabindex]="!d.disabledDate.disabled ? 0 : -1"
            (click)="onDayCellClicked($event, d)"
            (keydown)="onDayCellKeyDown($event, d)"
            (mouseenter)="onDayCellMouseEnter(d)"
            (mouseleave)="onDayCellMouseLeave()">
            @if (d.markedDate.marked && d.markedDate.color.length) {
              <span class="myDpMarkDate" [ngStyle]="{'border-top': '8px solid ' + d.markedDate.color}"></span>
            }
            <span  class="myDpDayValue"
              [attr.aria-label]="[(d.dateObj.month + '/' + d.dateObj.day + '/' + d.dateObj.year | date:'fullDate')]"
            [ngClass]="{'myDpMarkCurrDay': d.currDay && opts.markCurrentDay, 'myDpDimDay': d.highlight && (d.cmo===prevMonthId || d.cmo===nextMonthId || d.disabledDate.disabled), 'myDpHighlight': d.highlight}">{{d.dateObj.day}}</span>
          </td>
        }
      </tr>
    }
  </tbody>
</table>
